import React, { useEffect, useState, useContext } from "react";
import { useQuery } from "@apollo/react-hooks";
import { BannerCritical, Button, Drawer2, MobileContext } from "components/common";
import VerifyPaymentMethodInfo from "components/Pages/Dashboard/VerifyPaymentMethodInfo";
import GET_INVALID_INSTITUTE_IDS from "components/Pages/Dashboard/ActivateCard/gql-statements";
import { isPaymentBlacklistedFinicityId } from "components/Pages/Dashboard/ActivateCard/utils";
import { PAYMENT_METHODS_QUERY } from "utils";

const VerifyBankInfoBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { isMobile } = useContext(MobileContext);
  // use this to open by default when user logs in
  const verifyBankInfoDrawerDismissed = window.localStorage.getItem(
    "verifyBankInfoDrawerDismissed",
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const { loading, data: paymentMethodsData } = useQuery(
    PAYMENT_METHODS_QUERY,
    {},
  );
  const { data: invalidIdsData } = useQuery(GET_INVALID_INSTITUTE_IDS);

  const onCloseVerifyPaymentMethodInfoDrawer = () => {
    setDrawerOpen(false);
    window.localStorage.setItem("verifyBankInfoDrawerDismissed", true);
  };

  useEffect(() => {
    if (paymentMethodsData && invalidIdsData && paymentMethodsData.user?.card?.activated) {
      const invalidIds =
        invalidIdsData?.getSubstituteAccountNumberInstitutionIds || [];
      const paymentMethodsToUpdate =
        paymentMethodsData.user.payment_methods?.filter((pm) => {
          const { manually_updated_on, needs_account_routing_numbers } = pm;
          const isBlacklisted = isPaymentBlacklistedFinicityId(pm, invalidIds);
          return (
            (isBlacklisted && !manually_updated_on) ||
            needs_account_routing_numbers
          );
        }) || [];
      if (paymentMethodsToUpdate.length > 0) {
        setShowBanner(true);
        setPaymentMethods(paymentMethodsToUpdate);
        // only open by default when user first logs in
        setDrawerOpen(verifyBankInfoDrawerDismissed === null ? true : drawerOpen);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invalidIdsData, paymentMethodsData]);

  if (loading || !paymentMethodsData || !paymentMethodsData.user.card?.activated) {
    return null;
  }

  const onAllUpdated = () => {
    setDrawerOpen(false);
    setShowBanner(false);
  };

  const openVerifyBankInfoButton = () => {
    return (
      <Button
        className={`font-normal ${isMobile ? `-mb-2 mt-2` : ``}`}
        onClick={() => setDrawerOpen(true)}
        paddingHorizontal={`${isMobile ? 26 : 16}px`}
        paddingVertical={`${isMobile ? 6 : 8}px`}
      >
        Resolve Now
      </Button>
    );
  };

  if (paymentMethodsData.user.card.activated && paymentMethods.length > 0) {
    return (
      <>
        {showBanner && (
          <BannerCritical
            title="One or more of your payment methods need to be updated."
            type="warning"
            hasModal={false}
            ButtonComponent={openVerifyBankInfoButton()}
          />
        )}

        <Drawer2
          isOpen={drawerOpen}
          close={onCloseVerifyPaymentMethodInfoDrawer}
        >
          <VerifyPaymentMethodInfo
            paymentMethods={paymentMethods}
            setPaymentMethods={setPaymentMethods}
            onAllUpdated={onAllUpdated}
          />
        </Drawer2>
      </>
    );
  }

  return null;
};

export default VerifyBankInfoBanner;
